<template>
    <button
        type="reset"
        class="btn btn-secondary"
        @click.prevent="onDownload"
    >
        <slot>{{ $t('button.print') }}</slot>
    </button>
</template>

<script setup lang="ts">

import html2canvas from "html2canvas";
import printJS from "print-js";

const { pdfContent } = defineProps<{
    pdfContent: any
}>()

const onDownload = async () => {
    const canvas = await html2canvas(pdfContent, {scale: 2})
    const imgData = canvas.toDataURL('image/png');
    printJS({
        printable: imgData,
        type: 'image',
        base64: true,
        font_size: '11pt',
        maxWidth: 595,
        style: `{
             @page {
              size: ${canvas.width}px ${canvas.height}px;
              margin: 0;
            }

            body {
              margin: 0;
            }

            img {
              display: block;
              width: ${canvas.width}px;
              height: ${canvas.height}px;
            }
        }`
    })
}
</script>

<style scoped>

</style>
